import apiClient from "./blogApiClient";

/**
 * blogService provides methods to interact with blog posts and categories via API.
 *
 * @namespace blogService
 *
 * @property {function(): Promise<Object[]>} getAllBlogs - Fetches all blog posts (up to 100).
 * @property {function(number|string): Promise<Object>} getBlogById - Fetches a single blog post by its ID.
 * @property {function(string): Promise<Object[]>} getBlogBySlug - Fetches blog posts by their slug.
 * @property {function(string): Promise<Object[]>} getBlogByCategory - Fetches blog posts by category ID(s).
 * @property {function(): Promise<Object[]>} getAllCategories - Fetches all blog categories.
 * @property {function(number|string): Promise<Object>} getSingleCategory - Fetches a single category by its ID.
 */
const blogService = {
  getAllBlogs: async (perPage = 100) => {
    try {
      const response = await apiClient.get(`/posts?per_page=${perPage}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching blogs:", error);
      throw error;
    }
  },

  getBlogById: async (id) => {
    try {
      const response = await apiClient.get(`/posts/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching blog by ID:", error);
      throw error;
    }
  },

  getBlogBySlug: async (slug) => {
    try {
      const response = await apiClient.get(`/posts?slug=${slug}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching blog by slug:", error);
      throw error;
    }
  },

  getBlogByCategory: async (categoryIds) => {
    try {
      // categoryIds can be a single ID or a comma-separated list of IDs
      const response = await apiClient.get(`/posts?categories=${categoryIds}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching blogs by category:", error);
      throw error;
    }
  },

  getAllCategories: async () => {
    try {
      const response = await apiClient.get("/categories");
      return response.data;
    } catch (error) {
      console.error("Error fetching categories:", error);
      throw error;
    }
  },

  getSingleCategory: async (categoryId) => {
    try {
      const response = await apiClient.get(`/categories/${categoryId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching single category:", error);
      throw error;
    }
  },
};

export { blogService };
